export const HEADER_CHIP_STORAGE_KEY = 'tenantDetail.headerChips'

export const HEADER_CHIP_IDS = [
  'balanceTotal',
  'keBalanceTotal',
  'balanceDue',
  'keAccount',
  'utilityAccount',
  'billingStanding',
  'billingOpsStatus',
  'vnemStatus',
  'billingMode',
  'paperless',
  'autopay',
  'optiRate',
] as const

export type HeaderChipId = (typeof HEADER_CHIP_IDS)[number]

export const DEFAULT_HEADER_CHIP_IDS: HeaderChipId[] = [
  'balanceTotal',
  'billingStanding',
  'billingOpsStatus',
  'billingMode',
  'paperless',
  'autopay',
]

export const HEADER_CHIP_LABELS: Record<HeaderChipId, string> = {
  balanceTotal: 'Bal Total',
  keBalanceTotal: 'KE Bal Total',
  balanceDue: 'Bal Due',
  keAccount: 'KE Account',
  utilityAccount: 'Utility Account',
  billingStanding: 'Billing Standing',
  billingOpsStatus: 'Billing Status',
  vnemStatus: 'VNEM Status',
  billingMode: 'Billing Mode',
  paperless: 'Paperless',
  autopay: 'AutoPay',
  optiRate: 'OptiRate',
}

export const unpinnedGeneralOverflowChips = (pinnedChipIds: readonly HeaderChipId[]): HeaderChipId[] => {
  const pinned = new Set(pinnedChipIds)
  return HEADER_CHIP_IDS.filter((id) => !pinned.has(id))
}

const ALLOWED_IDS = new Set<string>(HEADER_CHIP_IDS)

export const parseHeaderChipIds = (raw: unknown): HeaderChipId[] | null => {
  if (!Array.isArray(raw)) return null
  const selected = new Set<HeaderChipId>()
  for (const value of raw) {
    if (typeof value === 'string' && ALLOWED_IDS.has(value)) {
      selected.add(value as HeaderChipId)
    }
  }
  return HEADER_CHIP_IDS.filter((id) => selected.has(id))
}

export const readHeaderChipIds = (): HeaderChipId[] => {
  try {
    const stored = localStorage.getItem(HEADER_CHIP_STORAGE_KEY)
    if (stored == null) return [...DEFAULT_HEADER_CHIP_IDS]
    const parsed = parseHeaderChipIds(JSON.parse(stored) as unknown)
    return parsed ?? [...DEFAULT_HEADER_CHIP_IDS]
  } catch {
    return [...DEFAULT_HEADER_CHIP_IDS]
  }
}

export const writeHeaderChipIds = (ids: HeaderChipId[]): void => {
  try {
    localStorage.setItem(HEADER_CHIP_STORAGE_KEY, JSON.stringify(ids))
  } catch {
    // ignore quota / private mode
  }
}

export const toggleHeaderChip = (current: readonly HeaderChipId[], id: HeaderChipId): HeaderChipId[] => {
  const selected = new Set(current)
  if (selected.has(id)) selected.delete(id)
  else selected.add(id)
  return HEADER_CHIP_IDS.filter((chip) => selected.has(chip))
}
